export var JoyCrmIntegrationServiceFunction;
(function (JoyCrmIntegrationServiceFunction) {
    JoyCrmIntegrationServiceFunction["userLocation"] = "userLocation";
    JoyCrmIntegrationServiceFunction["photoClientsSearch"] = "photoClientsSearch";
    JoyCrmIntegrationServiceFunction["sendPublicAlbum"] = "sendPublicAlbum";
})(JoyCrmIntegrationServiceFunction || (JoyCrmIntegrationServiceFunction = {}));
export default class JoyCrmIntegrationService {
    static initialize(provider) {
        JoyCrmIntegrationService.provider = provider;
    }
    static get instance() {
        return JoyCrmIntegrationService.provider;
    }
}
JoyCrmIntegrationService.provider = null;
//# sourceMappingURL=JoyCrmIntegrationService.js.map